<template>
  <main class="w-full flex-grow p-6">
    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2 mb-10">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">
              Destination Banner (1440 px X 569 px)
            </div>
            <div @click="showModalBanner" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="flex">
            <img
              :src="destinationBanner.banner"
              @click="showModal(destinationBanner.banner)"
              alt="23paskal-destination-banner"
              class="w-96 h-52 cursor-pointer"
            />
          </div>
        </div>
      </div>
    </div>

    <button
      @click="showModalDestination"
      class="block px-3 h-9 hover:text-white focus:ring focus:ring-primary-default focus:ring-opacity-30 focus:outline-none rounded-md text-sm bg-app-default hover:bg-app-light text-white mb-3 font-bold"
    >
      Add New Destination
    </button>

    <div class="w-full lg:w-1/4 pr-0 lg:pr-2">
      <input
        v-model="table.search"
        @keyup="searchSubscriber"
        type="text"
        class="w-full h-9 px-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200 mb-5"
        placeholder="Search name"
      />
    </div>

    <div class="mt-2 mb-5">
      <table class="w-full mx-auto table-auto">
        <thead class="justify-between">
          <tr class="bg-gray-600">
            <th class="px-5 py-2">
              <span class="text-gray-100 font-semibold">No</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Name</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Image</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Option</span>
            </th>
          </tr>
        </thead>
        <tbody class="bg-gray-200">
          <tr
            v-for="(sos, index) in destinations"
            :key="sos.id"
            :class="[index % 2 !== 0 ? 'bg-gray-200' : '']"
            class="bg-white border-b-2 border-gray-200"
          >
            <td class="px-5 py-2 text-center">
              {{
                table.current_page === 1
                  ? index + 1
                  : index + 1 + (table.current_page - 1) * table.per_page
              }}
            </td>
            <td class="text-center">
              <span class="font-semibold">
                {{ sos.destination_name }}
              </span>
            </td>
            <td class="p-2">
              <div class="flex items-center justify-center">
                <img
                  v-if="sos.destination_images"
                  class="w-10 h-10 cursor-pointer"
                  :src="sos.destination_images"
                  alt="23paskal"
                  @click="showModal(sos.destination_images)"
                />
              </div>
            </td>
            <td class="">
              <div class="flex items-center justify-evenly">
                <button class="" type="button" @click="detailContent(sos.id)">
                  <span class="font-bold text-app-default">
                    More
                  </span>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
      <div>
        <p class="text-sm text-gray-700">
          Showing
          <span class="font-medium">
            {{ table.current_page * table.per_page - table.per_page + 1 }}
          </span>
          to
          <span class="font-medium">
            {{ table.current_page * table.per_page }}
          </span>
          of
          <span class="font-medium">{{ table.total }}</span>
          results
        </p>
      </div>
      <div>
        <nav
          class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
          aria-label="Pagination"
        >
          <button
            type="button"
            @click="previewPage"
            :disabled="table.current_page === 1"
            class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
          >
            <span class="sr-only">Previous</span>
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </button>

          <div v-if="Math.ceil(table.total / table.per_page) < 5" class="">
            <button
              v-for="pg in Math.ceil(table.total / table.per_page)"
              :key="pg"
              @click="findpage(pg)"
              type="button"
              aria-current="page"
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page === pg
                  ? 'bg-app-default text-white'
                  : 'bg-white text-black',
              ]"
            >
              {{ pg }}
            </button>
          </div>
          <div v-else class="">
            <button
              @click="findpage(1)"
              type="button"
              aria-current="page"
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page === 1
                  ? 'bg-app-default text-white'
                  : 'bg-white text-black',
              ]"
            >
              1
            </button>

            <button
              @click="
                findpage(
                  table.current_page === 1
                    ? 2
                    : table.current_page === 2
                    ? 2
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page)
                    ? table.current_page - 3
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page) - 1
                    ? table.current_page - 2
                    : table.current_page - 1
                )
              "
              type="button"
              aria-current="page"
              :disabled="
                Math.ceil(table.total / table.per_page) - 1 ===
                  table.current_page
              "
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page === 1
                  ? 'bg-white text-black'
                  : table.current_page === 2
                  ? 'bg-app-default text-white'
                  : 'bg-white text-black',
              ]"
            >
              {{
                table.current_page === 1
                  ? 2
                  : table.current_page === 2
                  ? 2
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page)
                  ? table.current_page - 3
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page) - 1
                  ? table.current_page - 2
                  : table.current_page - 1
              }}
            </button>

            <button
              @click="
                findpage(
                  table.current_page === 1
                    ? 3
                    : table.current_page === 2
                    ? 3
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page) - 1
                    ? table.current_page - 1
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page)
                    ? table.current_page - 2
                    : table.current_page
                )
              "
              type="button"
              aria-current="page"
              :disabled="
                Math.ceil(table.total / table.per_page) - 1 ===
                  table.current_page
              "
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page ===
                Math.ceil(table.total / table.per_page) - 1
                  ? 'bg-white text-black'
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page)
                  ? 'bg-white text-black'
                  : table.current_page === 1
                  ? 'bg-white text-black'
                  : table.current_page === 2
                  ? 'bg-white text-black'
                  : 'bg-app-default text-white',
              ]"
            >
              {{
                table.current_page === 1
                  ? 3
                  : table.current_page === 2
                  ? 3
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page) - 1
                  ? table.current_page - 1
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page)
                  ? table.current_page - 2
                  : table.current_page
              }}
            </button>

            <button
              @click="
                findpage(
                  table.current_page === 1
                    ? 4
                    : table.current_page === 2
                    ? 4
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page) - 1
                    ? Math.ceil(table.total / table.per_page) - 1
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page)
                    ? table.current_page - 1
                    : table.current_page + 1
                )
              "
              type="button"
              aria-current="page"
              :disabled="
                Math.ceil(table.total / table.per_page) - 1 ===
                  table.current_page
              "
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page ===
                Math.ceil(table.total / table.per_page) - 2
                  ? 'bg-white text-black'
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page) - 3
                  ? 'bg-white text-black'
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page)
                  ? 'bg-white text-black'
                  : table.current_page > 1 &&
                    table.current_page <
                      Math.ceil(table.total / table.per_page) - 1
                  ? 'bg-white text-black'
                  : table.current_page === 1
                  ? 'bg-white text-black'
                  : 'bg-app-default text-white',
              ]"
            >
              {{
                table.current_page === 1
                  ? 4
                  : table.current_page === 2
                  ? 4
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page) - 1
                  ? Math.ceil(table.total / table.per_page) - 1
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page)
                  ? table.current_page - 1
                  : table.current_page + 1
              }}
            </button>

            <button
              @click="findpage(Math.ceil(table.total / table.per_page))"
              type="button"
              aria-current="page"
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page === Math.ceil(table.total / table.per_page)
                  ? 'bg-app-default text-white'
                  : 'bg-white text-black',
              ]"
            >
              {{ Math.ceil(table.total / table.per_page) }}
            </button>
          </div>
          <!-- <button v-for="pg in Math.ceil(table.total / table.per_page)" :key="pg" @click="findpage(pg)" type="button" aria-current="page" class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium" :class="[table.current_page === pg ? 'bg-app-default text-white' : 'bg-white text-black']">
            {{ pg }}
          </button> -->

          <button
            type="button"
            @click="nexPage"
            :disabled="
              Math.ceil(table.total / table.per_page) === table.current_page
            "
            class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
          >
            <span class="sr-only">Next</span>
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </nav>
      </div>
    </div>

    <!-- Modal Banner -->
    <div
      v-if="modalBanner"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="showModalBanner"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">
            Banner (1440 px X 569 px)
          </div>
          <div class="p-6 flex-grow">
            <div
              class="border-dotted border-2 border-black p-2 rounded-lg"
              @drop="previewBanner"
            >
              <input
                type="file"
                accept="image/*"
                @change="previewBanner"
                id="banner"
                class="opacity-0 hidden"
              />
              <div class="flex flex-row">
                <div
                  v-if="update.previewBanner"
                  class="mr-1 relative rounded-lg w-full"
                >
                  <button
                    class="absolute right-2 top-2"
                    type="button"
                    @click="removeBannerFile"
                  >
                    <fas icon="trash-alt" class="text-red-600 text-3xl" />
                  </button>
                  <img
                    :src="update.previewBanner"
                    class="w-full h-80 rounded-lg"
                  />
                </div>
                <div
                  v-if="update.previewBanner === null"
                  v-cloak
                  @click="chooseBannerFile()"
                  class="w-full h-80 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                >
                  <fas icon="image" class="text-gray-600 text-3xl" />
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalBanner"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                :disabled="!update.previewBanner"
                @click="updateBannerDestination"
                type="button"
                class="text-gray-200 rounded px-4 py-2 w-32"
                :class="[!update.previewBanner ? 'bg-gray-500' : 'bg-blue-600']"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalBanner"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- modal create -->
    <div
      v-if="modalCreateDestination"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 1000px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">Add New Destination</div>
            <div class="">
              <button
                @click.self="showModalDestination"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="w-full pr-0 lg:pr-2">
              <label class="font-semibold text-black opacity-80"
                >Destination Status</label
              >
              <div class="flex flex-row items-center h-9 mb-5">
                <div
                  class="relative cursor-pointer"
                  @click="create.is_active = !create.is_active"
                >
                  <div
                    class="w-10 h-4 bg-gray-400 rounded-full shadow-inner items-center p-1 duration-300 ease-in-out"
                    :class="{ 'bg-app-default': create.is_active }"
                  ></div>
                  <div
                    class="absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition transform duration-300 ease-in-out"
                    :class="{ 'translate-x-6': create.is_active }"
                  ></div>
                </div>
              </div>
            </div>
            <label class="font-semibold text-black opacity-80"
              >Image (1020 px X 1020 px)</label
            >
            <div class="w-80">
              <div
                class="border-dotted border-2 p-2 rounded-lg"
                :class="[
                  errors.destination_images ? 'border-red-400' : 'border-black',
                ]"
                @drop="previewProductDestination"
              >
                <input
                  type="file"
                  accept="image/*"
                  @change="previewProductDestination"
                  id="product_file"
                  class="opacity-0 hidden"
                />
                <div class="flex flex-row flex-wrap">
                  <div
                    v-if="avatar.previewFileProduct.length"
                    class="relative rounded-lg"
                  >
                    <button
                      class="absolute right-2 top-2"
                      type="button"
                      @click="removeProductDestination"
                    >
                      <fas icon="trash-alt" class="text-red-600 text-3xl" />
                    </button>
                    <img
                      :src="avatar.previewFileProduct[0]"
                      class="w-80 h-80 rounded-lg"
                    />
                  </div>
                  <div
                    v-if="avatar.previewFileProduct.length === 0"
                    v-cloak
                    @click="chooseSingleFile()"
                    class="w-80 h-80 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                  >
                    <fas icon="image" class="text-gray-600 text-3xl" />
                  </div>
                </div>
              </div>
              <div class="text-sm text-red-600 mb-5">
                {{ errors.destination_images_msg }}
              </div>
            </div>
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80">Name</label>
                <input
                  v-model="create.destination_name"
                  @keyup="destinationNameChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.destination_name
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.destination_name_msg }}
                </div>
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Description</label
                >
                <!-- <textarea
                  v-model="create.destination_description"
                  @keyup="destinationDescriptionChange"
                  rows="5"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.destination_description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Description"
                >
                </textarea> -->
                <div
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.destination_description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                >
                  <CKEditor
                    v-model="create.destination_description"
                    :disabled="false"
                    :toolbar="toolbar"
                    @onChange="destinationDescriptionChange"
                  />
                </div>
                <div
                  class="text-right text-sm "
                  :class="[
                    create?.destination_description?.length <= 2000
                      ? 'text-gray-600'
                      : 'text-red-600',
                  ]"
                >
                  {{ create?.destination_description?.length }} used out of 2000
                  characters
                </div>
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.destination_description_msg }}
                </div>
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Contact</label
                >
                <input
                  v-model="create.destination_contact"
                  @keyup="destinationContactChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.destination_contact
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="ex: 08123456789"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.destination_contact_msg }}
                </div>
              </div>
              <div class="w-1/3 pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Operation Day</label
                >
                <input
                  v-model="create.destination_operation_day"
                  @keyup="destinationDayChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.destination_operation_day
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="ex: Mon - Fri"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.destination_operation_day_msg }}
                </div>
              </div>
              <div class="w-1/3 pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Time Open</label
                >
                <input
                  v-model="create.destination_open_time"
                  @change="destinationOpenTimeChange"
                  type="time"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.destination_open_time
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.destination_open_time_msg }}
                </div>
              </div>
              <div class="w-1/3 pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Time Closed</label
                >
                <input
                  v-model="create.destination_closed_time"
                  @change="destinationClosedTimeChange"
                  type="time"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.destination_closed_time
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.destination_closed_time_msg }}
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalDestination"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Cancel
              </button>
              <!-- :disabled="avatar.previewFileProduct.length === 0 && avatar.previewFileCarousel.length === 0" -->
              <button
                @click="createDestination"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalDestination"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>
    <Modal v-show="isModalVisible" @close="closeModal" :imageso="imageso" />
    <Warning />
    <SuccessNotif />
  </main>
</template>

<script>
import API from "../../api";
import CKEditor from "../../components/CKEditor.vue";
import Modal from "../../components/Modal.vue";
import Warning from "../../components/Warning.vue";
import SuccessNotif from "../../components/SuccessNotif.vue";
export default {
  name: "Destination",
  components: {
    Modal,
    Warning,
    SuccessNotif,
    CKEditor,
  },
  data() {
    return {
      toolbar: {
        items: [
          "bold",
          "italic",
          "underline",
          "|",
          "superscript",
          "subscript",
          "strikethrough",
          "|",
          "outdent",
          "indent",
          "alignment",
          "|",
          "undo",
          "redo",
        ],
      },
      imageso: "",
      isModalVisible: false,
      modalBanner: false,
      modalCreateDestination: false,
      destinations: [],
      destinationBanner: {},
      update: {
        previewBanner: null,
        fileBanner: null,
      },
      errors: {
        destination_images: false,
        destination_carousel: false,
        destination_images_msg: "",
        destination_carousel_msg: "",
        destination_name: false,
        destination_name_msg: "",
        destination_description: false,
        destination_description_msg: "",
        destination_contact: false,
        destination_contact_msg: "",
        destination_operation_day: false,
        destination_operation_day_msg: "",
        destination_open_time: false,
        destination_open_time_msg: "",
        destination_closed_time: false,
        destination_closed_time_msg: "",
        is_active: false,
        is_active_msg: "",
      },
      table: {
        current_page: 1,
        per_page: 10,
        search: "",
        total: 0,
      },
      avatar: {
        previewFileProduct: [],
        fileProduct: [],
        previewFileCarousel: null,
        fileCarousel: null,
      },
      create: {
        destination_name: "",
        destination_description: "",
        destination_contact: "",
        destination_operation_day: "",
        destination_open_time: "12:00",
        destination_closed_time: "17:00",
        is_active: true,
      },
      saveButton: "Save",
    };
  },
  methods: {
    showModal: function(data) {
      this.imageso = data;
      this.isModalVisible = true;
    },
    closeModal: function() {
      this.isModalVisible = false;
    },
    showModalBanner: function() {
      this.modalBanner = !this.modalBanner;
    },
    previewBanner: function(event) {
      let input = event.target;
      if (input.files) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.update.previewBanner = e.target.result;
        };
        this.update.fileBanner = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
    },
    removeBannerFile: function() {
      this.update.previewBanner = null;
      this.update.fileBanner = null;
    },
    chooseBannerFile: function() {
      document.getElementById("banner").click();
    },
    updateBannerDestination: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("banner", this.update.fileBanner);
      formdata.append("id", this.destinationBanner.id);
      try {
        let res = await fetch(`${API}v1/admin/cms/destination/banner/update`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          this.modalBanner = false;
          this.saveButton = "Save";
          this._error(response.message);
          return;
        }
        this.modalBanner = false;
        this.findDestinationBanner();
        this.saveButton = "Save";
        this._success("Data updated.");
      } catch (err) {
        this.modalBanner = false;
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    findDestinationBanner: async function() {
      try {
        let res = await fetch(`${API}v1/destination_banner`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error(respon.message);
          return;
        }
        this.destinationBanner = respon.data;
      } catch (err) {
        this._error("internal server error");
      }
    },
    destinationNameChange: function(e) {
      this.create.destination_name = e.target.value;
      this.errors.destination_name = false;
      this.errors.destination_name_msg = "";
    },
    destinationDescriptionChange: function() {
      // this.create.destination_description = e.target.value;
      this.errors.destination_description = false;
      this.errors.destination_description_msg = "";
    },
    destinationContactChange: function(e) {
      this.create.destination_contact = e.target.value;
      this.errors.destination_contact = false;
      this.errors.destination_contact_msg = "";
    },
    destinationDayChange: function(e) {
      this.create.destination_operation_day = e.target.value;
      this.errors.destination_operation_day = false;
      this.errors.destination_operation_day_msg = "";
    },
    destinationOpenTimeChange: function(e) {
      this.create.destination_open_time = e.target.value;
      this.errors.destination_open_time = false;
      this.errors.destination_open_time_msg = "";
    },
    destinationClosedTimeChange: function(e) {
      this.create.destination_closed_time = e.target.value;
      this.errors.destination_closed_time = false;
      this.errors.destination_closed_time_msg = "";
    },
    searchSubscriber: function() {
      this.current_page = 1;
      this.per_page = 10;
      this.findDestination();
    },
    nexPage: function() {
      this.table.current_page = this.table.current_page + 1;
      this.findDestination();
    },
    previewPage: function() {
      this.table.current_page = this.table.current_page - 1;
      this.findDestination();
    },
    findpage: function(page) {
      this.table.current_page = page;
      this.findDestination();
    },
    detailContent: function(id) {
      this.$router.push(this.$route.path + "/" + id);
    },
    chooseSingleFile: function() {
      document.getElementById("product_file").click();
    },
    removeProductDestination: function() {
      this.avatar.previewFileProduct = [];
      this.avatar.fileProduct = [];
    },
    chooseFileLocation: function() {
      document.getElementById("carousel_file").click();
    },
    removeCarouselDestination: function() {
      this.avatar.fileCarousel = null;
      this.avatar.previewFileCarousel = null;
    },
    previewProductDestination: function(event) {
      let input = event.target;
      let count = input.files.length;
      let index = 0;
      if (input.files) {
        while (count--) {
          let reader = new FileReader();
          reader.onload = (e) => {
            this.avatar.previewFileProduct.push(e.target.result);
          };
          this.avatar.fileProduct.push(input.files[index]);
          reader.readAsDataURL(input.files[index]);
          index++;
        }
      }
      this.errors.destination_images = false;
      this.errors.destination_images_msg = "";
    },
    previewCarouselDestination: function(event) {
      let input = event.target;
      if (input.files) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.avatar.previewFileCarousel = e.target.result;
        };
        this.avatar.fileCarousel = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
      this.errors.destination_carousel = false;
      this.errors.destination_carousel_msg = "";
    },
    showModalDestination: function() {
      (this.avatar = {
        previewFileProduct: [],
        fileProduct: [],
        previewFileCarousel: null,
        fileCarousel: null,
      }),
        (this.create = {
          destination_name: "",
          destination_description: "",
          destination_contact: "",
          destination_operation_day: "",
          destination_open_time: "12:00",
          destination_closed_time: "17:00",
          is_active: true,
        }),
        (this.modalCreateDestination = !this.modalCreateDestination);
    },
    findDestination: async function() {
      try {
        let res = await fetch(
          `${API}v1/admin/cms/destination?current_page=${this.table.current_page}&per_page=${this.table.per_page}&search=${this.table.search}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.destinations = respon.data.destinations;
        this.table.current_page = respon.data.current_page;
        this.table.per_page = respon.data.per_page;
        // this.table.search = respon.data.search
        this.table.total = respon.data.total;
      } catch (err) {
        this._error("internal server error");
      }
    },
    createDestination: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("destination_name", this.create.destination_name);
      formdata.append(
        "destination_description",
        this.create.destination_description
      );
      formdata.append("destination_contact", this.create.destination_contact);
      formdata.append(
        "destination_operation_day",
        this.create.destination_operation_day
      );
      formdata.append(
        "destination_open_time",
        this.create.destination_open_time
      );
      formdata.append(
        "destination_closed_time",
        this.create.destination_closed_time
      );
      formdata.append("destination_carousel", this.avatar.fileCarousel);
      this.avatar.fileProduct.map((product) => {
        formdata.append("destination_images", product);
      });
      formdata.append("is_active", this.create.is_active);
      // // Display the key/value pairs
      // for (var pair of formdata.entries()) {
      //   console.log(pair[0] + ", " + pair[1]);
      // }
      try {
        let res = await fetch(`${API}v1/admin/cms/destination/store`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "destination_images") {
                this.errors.destination_images = true;
                this.errors.destination_images_msg = item.message;
              }
              if (item.key === "destination_carousel") {
                this.errors.destination_carousel = true;
                this.errors.destination_carousel_msg = item.message;
              }
              if (item.key === "destination_name") {
                this.errors.destination_name = true;
                this.errors.destination_name_msg = item.message;
              }
              if (item.key === "destination_description") {
                this.errors.destination_description = true;
                this.errors.destination_description_msg = item.message;
              }
              if (item.key === "destination_contact") {
                this.errors.destination_contact = true;
                this.errors.destination_contact_msg = item.message;
              }
              if (item.key === "destination_operation_day") {
                this.errors.destination_operation_day = true;
                this.errors.destination_operation_day_msg = item.message;
              }
              if (item.key === "destination_open_time") {
                this.errors.destination_open_time = true;
                this.errors.destination_open_time_msg = item.message;
              }
              if (item.key === "destination_closed_time") {
                this.errors.destination_closed_time = true;
                this.errors.destination_closed_time_msg = item.message;
              }
              if (item.key === "is_active") {
                this.errors.is_active = true;
                this.errors.is_active_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.saveButton = "Save";
          return;
        }
        this.modalCreateDestination = false;
        this.saveButton = "Save";
        this.findDestination();
        this._success("Data has been saved.");
      } catch (err) {
        this.saveButton = "Save";
        this.modalCreateDestination = false;
        this._error("internal server error");
      }
    },
    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", {
          isError: false,
          message: "",
        });
      }, 5000);
    },
    _success: function(message) {
      this.$store.dispatch("success", {
        isSuccess: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("success", {
          isSuccess: false,
          message: "",
        });
      }, 5000);
    },
  },
  created: function() {
    this.findDestination();
    this.findDestinationBanner();
  },
};
</script>
